import { render, staticRenderFns } from "./NewsTile.vue?vue&type=template&id=f1ee61b2&scoped=true&"
import script from "./NewsTile.vue?vue&type=script&lang=js&"
export * from "./NewsTile.vue?vue&type=script&lang=js&"
import style0 from "./NewsTile.vue?vue&type=style&index=0&id=f1ee61b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ee61b2",
  null
  
)

export default component.exports